module.exports = __webpack_public_path__ + "img/type-bold.9a6692bb.svg";